import { useQuery } from "@tanstack/react-query";
import { fetchDailySpecialists } from "@/lib/services/staffService";
import type { Specialist } from "@/lib/types";

/**
 * React Query hook for fetching specialists for a specific date.
 * @param date - The date string (YYYY-MM-DD)
 */
export function useSpecialistsForDate(date: string) {
  return useQuery<Specialist[]>({
    queryKey: ["specialistsForDate", date],
    queryFn: () => fetchDailySpecialists(date),
    enabled: !!date,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 60_000, // defensive liveness for passive viewers (doc 07 Phase B)
  });
}
